import { render, staticRenderFns } from "./ControlTable2.vue?vue&type=template&id=9f738e28&scoped=true"
import script from "./ControlTable2.vue?vue&type=script&lang=js"
export * from "./ControlTable2.vue?vue&type=script&lang=js"
import style0 from "./ControlTable2.vue?vue&type=style&index=0&id=9f738e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f738e28",
  null
  
)

export default component.exports